


















import { Component, Prop, Vue } from "vue-property-decorator";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { INotificationHook } from "@/models/notifications";
import { ITemplate } from "@/models/templates";
import TemplateProvider from "@/components/app/global/templates/templateProvider.vue";
import NotificationTemplateAddEditForm from "@/components/app/global/templates/notifications/templateAddEditForm.vue";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  components: {
    TemplateProvider,
    NotificationTemplateAddEditForm
  }
})
export default class AdminAutomationEditActionForm extends Vue {
  // Refs
  public $refs!: {
    templateProvider: TemplateProvider;
  };

  // Props
  @Prop({ default: null })
  public templateId!: ITemplate["id"];

  @Prop({ default: null })
  public channelCode!: NotificationChannelCodes;

  @Prop({ default: null })
  public hookId!: INotificationHook["id"];

  // Data
  public templateType = TemplateTypes.NOTIFICATION;

  // Methods

  public onDuplicate({ newTemplate }) {
    this.$router.replace({
      name: "adminEditAutomationAction",
      params: { templateId: newTemplate.id }
    });
  }

  public onSave() {
    if (this.$refs.templateProvider?.isNew)
      this.$router.push({
        name: "adminAutomationChannels"
      });
  }

  public onChange({ templateId }) {
    this.$router.replace({
      name: this.$route.name as string,
      params: { templateId }
    });
  }

  public onRestored({ templateId }: { templateId: ITemplate["id"] }) {
    this.$router.replace({
      name: "adminEditAutomationAction",
      params: { templateId }
    });
  }
}
